import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './ReleaseRefundTicketModal.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class ReleaseRefundTicketModal extends Component {
    constructor(props) {
		super(props);
		this.state = { 
			face: 0,
			total: 0,
        }
    }

	componentWillReceiveProps(props) {
		let refundTicketId = props.refundTicketId;
		let refundFlexpassId = props.refundFlexpassId;
		let total = 0;
		if (props.refundDetails) {
			props.refundDetails.forEach((refundDetail) => {
				if (refundDetail.transaction_tickets_id && parseInt(refundDetail.transaction_tickets_id, 10) === parseInt(refundTicketId, 10)) {
					total += refundDetail.price;
				}
				if (refundFlexpassId) {
					if (refundDetail.transaction_flexpass_id && parseInt(refundDetail.transaction_flexpass_id, 10) === parseInt(refundFlexpassId, 10)) {
						total = refundDetail.price;
					}
				}
			});
			
		}
		
		this.setState({
			total,
		});
	}

    render() {
	  	return (
			<div>
		  		<Modal isOpen={this.props.isReleaseRefundTicketOpen} toggle={this.toggle}>
		          	<ModalHeader toggle={this.props.toggleReleaseRefundModal}>{strings.title}</ModalHeader>
		          	<ModalBody>
						<p>{strings.refundDesc1}
							{new Intl.NumberFormat('en-US', {
								style: 'currency',
								currency: 'USD'
							}).format(this.state.total)}
							{strings.refundDesc2}</p>
						<p>{strings.patrons}</p>
						<table className="showtix-table showtix-table__striped">
							<thead>
								<tr>
									<th>
										{strings.tickets}
									</th>
									<th>
										{strings.showtixFees}
									</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td className="is-right">
										√
									</td>
									<td className="is-wrong">
										X
									</td>
								</tr>
							</tbody>
						</table>
						<div className="d-flex justify-content-center mt-4">
							<button 
								className="showtix-button showtix-background__grey-1"
								onClick={this.props.toggleReleaseRefundModal}
								>{strings.cancel}</button>
							<button 
								className="showtix-button showtix-background__primary-3"
								onClick={() => this.props.confirmTicketRefund()}
								>{strings.confirm}</button>    
		          		</div>
					</ModalBody>
		        </Modal>
			</div>
	  	);
	}
}

ReleaseRefundTicketModal.propTypes = {
    isReleaseRefundTicketOpen: PropTypes.bool,
    toggleReleaseRefundModal: PropTypes.func,
	confirmAlertModal: PropTypes.func,
	confirmTicketRefund: PropTypes.func,
	refundTicketId: PropTypes.string,
}

export default ReleaseRefundTicketModal;


// WEBPACK FOOTER //
// ./src/components/Search/ReleaseRefundTicketModal/ReleaseRefundTicketModal.js